import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories, getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCat = categories.find((c) => c.slug === slug) || categories[0];
  const catArticles = getArticlesByCategory(currentCat.slug);
  const [activeCat, setActiveCat] = useState(currentCat.slug);

  useEffect(() => {
    if (slug && categories.some(c => c.slug === slug)) {
      setActiveCat(slug);
    }
  }, [slug]);

  const displayedArticles = getArticlesByCategory(activeCat);

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${currentCat.name} - 亚洲综合资讯`}
        description={`亚洲综合网${currentCat.name}频道，汇聚亚洲${currentCat.name}领域最新、最全的资讯内容，为您提供权威的亚洲${currentCat.name}综合信息服务。`}
        keywords={`亚洲${currentCat.name},亚洲${currentCat.name}资讯,亚洲${currentCat.name}新闻,亚洲综合网${currentCat.name}`}
        canonicalUrl={`https://985huidian.cn/category/${currentCat.slug}`}
      />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" data={{
        name: `${currentCat.name} - 亚洲综合网`,
        url: `https://985huidian.cn/category/${currentCat.slug}`,
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: currentCat.name },
          ]}
        />

        <main className="max-w-[1280px] mx-auto px-4 md:px-6 py-6">
          <div className="mb-8">
            <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-2">
              {currentCat.name}
            </h1>
            <p className="text-foreground-600 text-sm">
              浏览亚洲{currentCat.name}领域的最新资讯与深度报道
            </p>
          </div>

          {/* Category Tabs */}
          <div className="flex items-center gap-2 mb-8 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeCat === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-950'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {/* Featured Article */}
          {displayedArticles.length > 0 && (
            <div className="mb-10">
              <ArticleCard article={displayedArticles[0]} variant="featured" />
            </div>
          )}

          {/* Article List */}
          {displayedArticles.length > 1 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {displayedArticles.slice(1).map((article) => (
                <ArticleCard key={article.id} article={article} variant="default" />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-background-100">
                <i className="ri-article-line text-3xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">暂无更多文章</p>
            </div>
          )}
        </main>

        <Footer />
      </div>
    </>
  );
}